import React from 'react';
import { ArrowRight } from 'lucide-react';
export function AboutMe() {
  const missionItems = ['De la durere profundă la echilibru emoțional', 'De la confuzie și blocaj la claritate și direcție', 'De la frica de viitor la alegeri conștiente'];
  return <section className="bg-white py-24 md:py-32" data-id="element-16">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-17">
        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-18">
          {/* Content - on mobile comes first with titles centered */}
          <div className="space-y-8 order-1 lg:order-2" data-id="element-19">
            <div className="space-y-3 text-center lg:text-left" data-id="element-20">
              <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-21">
                Cine sunt eu
              </h2>
              <p className="text-xs font-medium tracking-widest uppercase text-muted" data-id="element-22">
                Life Coach · Terapeut în Vindecare Emoțională · Practitioner NLP
              </p>
            </div>

            {/* Image on mobile - between titles and text */}
            <div className="lg:hidden relative flex flex-col items-center" data-id="element-23">
              <div className="relative w-full max-w-sm" data-id="element-24">
                <div className="absolute -bottom-3 -right-3 w-full h-full rounded-2xl bg-blush border border-cardBorder" data-id="element-25"></div>
                <img src="https://cdn.magicpatterns.com/uploads/o7d4VTYFkfX7EGH5dv9xfR/DespreMine_organic_B_petale_elegante.jpg" alt="Simona Popa" className="relative z-10 w-full h-[450px] rounded-2xl object-cover object-top" data-id="element-26" />
              </div>
            </div>

            <div className="space-y-4 text-base leading-relaxed text-navy text-left" data-id="element-27">
              <p data-id="element-28">
                Sunt Simona Popa și lucrez cu femei aflate în crize majore de
                viață, doliu, pierdere, divorț sau colaps emoțional, care simt
                că au pierdut direcția și vor să își reconstruiască viața pe
                baze sănătoase.
              </p>

              <p data-id="element-29">
                Am trecut eu însămi prin traume profunde, bullying, burnout și
                momente de întuneric, iar în 2016 am fost la un pas de moarte
                după o operație complicată. Am ieșit din acea experiență cu o
                misiune clară.
              </p>

              <p data-id="element-30">
                Din 2019 susțin sesiuni 1 la 1 și am acumulat peste 700 de
                sesiuni și peste 3500 de ore de lucru cu oamenii. Metoda mea
                este Terapia T.P.V., un proces structurat care îmbină coaching,
                tehnici NLP și meditație ghidată.
              </p>
            </div>

            <div className="pt-6 border-t border-cardBorder space-y-6" data-id="element-31">
              <h3 className="font-serif text-2xl font-medium text-magenta text-center lg:text-left" data-id="element-32">
                Misiunea mea
              </h3>
              <ul className="space-y-4" data-id="element-33">
                {missionItems.map((item, index) => <li key={index} className="flex items-center gap-3 justify-start" data-id="element-34">
                    <ArrowRight className="w-5 h-5 text-cyan flex-shrink-0" strokeWidth={2} data-id="element-35" />
                    <span className="text-base text-navy" data-id="element-36">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center lg:text-left" data-id="element-37">
              <a href="https://project-about-me-page-374.magicpatterns.app/" className="inline-block bg-magenta text-white font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-cyan transition-colors duration-300" data-id="element-38">
                Află mai multe despre mine
              </a>
            </div>
          </div>

          {/* Desktop Image with decorative elements */}
          <div className="relative flex-col items-center hidden lg:flex order-2 lg:order-1" data-id="element-39">
            {/* Top decorative line */}
            <div className="flex items-center gap-3 mb-6" data-id="element-40">
              <div className="w-8 h-px bg-magenta/40" data-id="element-41"></div>
              <div className="w-2 h-2 rounded-full bg-magenta/30" data-id="element-42"></div>
              <div className="w-20 h-px bg-magenta/40" data-id="element-43"></div>
              <div className="w-2 h-2 rounded-full bg-cyan/30" data-id="element-44"></div>
              <div className="w-8 h-px bg-magenta/40" data-id="element-45"></div>
            </div>

            {/* Photo with offset background */}
            <div className="relative w-full md:w-5/6" data-id="element-46">
              <div className="absolute -bottom-3 -right-3 w-full h-full rounded-2xl bg-blush border border-cardBorder" data-id="element-47"></div>
              <img src="https://cdn.magicpatterns.com/uploads/o7d4VTYFkfX7EGH5dv9xfR/DespreMine_organic_B_petale_elegante.jpg" alt="Simona Popa" className="relative z-10 w-full h-[650px] rounded-2xl object-cover object-top" data-id="element-48" />
            </div>

            {/* Bottom decorative line */}
            <div className="flex items-center gap-3 mt-6" data-id="element-49">
              <div className="w-12 h-px bg-cyan/40" data-id="element-50"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-magenta/30" data-id="element-51"></div>
              <div className="w-16 h-px bg-cyan/40" data-id="element-52"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-cyan/30" data-id="element-53"></div>
              <div className="w-12 h-px bg-cyan/40" data-id="element-54"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}